import { render } from "./Diagnosis.vue?vue&type=template&id=a2870d92"
import script from "./Diagnosis.ts?vue&type=script&lang=js&external"
export * from "./Diagnosis.ts?vue&type=script&lang=js&external"

import "./Diagnosis.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__